export const computeLeftInfo = (
  title: string,
  description: string | number
) => {
  if (description) {
    if (title.includes("age")) {
      return `${description} YO`;
    }
    if (title.includes("weight")) {
      return `${description}lbs`;
    }
    return description;
  }
  return "-";
};

export const computePercentageOrValue = (
  value: number | undefined,
  entry: string
) => {
  if (value === null || value === undefined) {
    return "-";
  }
  if (value === 0) {
    return 0;
  }
  return entry.includes("Percentage") ? `${Math.round(value)}%` : value;
};

export const isTopStat = (value: number | undefined = 0, topStat: number) =>
  value >= topStat && value > 0;
